/*
 * Personal Digital Spaces LLC ("COMPANY") CONFIDENTIAL
 * Unpublished Copyright (c) 2025 Personal Digital Spaces LLC, All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains the property of COMPANY. The intellectual and technical concepts contained
 * herein are proprietary to COMPANY and may be covered by U.S. and Foreign Patents, patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material is strictly forbidden unless prior written permission is obtained
 * from COMPANY.  Access to the source code contained herein is hereby forbidden to anyone except current COMPANY employees, managers, contractors or partners who have executed
 * Confidentiality and Non-disclosure agreements explicitly covering such access.
 *
 * The copyright notice above does not evidence any actual or intended publication or disclosure  of  this source code, which includes
 * information that is confidential and/or proprietary, and is a trade secret, of  COMPANY.   ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC  PERFORMANCE,
 * OR PUBLIC DISPLAY OF OR THROUGH USE  OF THIS  SOURCE CODE  WITHOUT  THE EXPRESS WRITTEN CONSENT OF COMPANY IS STRICTLY PROHIBITED, AND IN VIOLATION OF APPLICABLE
 * LAWS AND INTERNATIONAL TREATIES.  THE RECEIPT OR POSSESSION OF  THIS SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY OR IMPLY ANY RIGHTS
 * TO REPRODUCE, DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING THAT IT  MAY DESCRIBE, IN WHOLE OR IN PART.
 */
import React, { useState } from 'react'
import VaultSetupForm from './components/VaultSetupForm'
import FeaturesForm from './components/FeaturesForm'
import Table from './components/Table'
import SectionContainer from './components/SectionContainer'
import Styles from './styles.module.sass'
import Tabs from './components/Tabs'
import { servicesRegisterUserLicenses } from '@/services/user-licenses'
import { useAuth0 } from '@auth0/auth0-react'

const LicensesForm = ({
  licenses,
  setScreenLoader,
  vaultBinding
}) => {
  const { getAccessTokenSilently: getAccessToken } = useAuth0()
  const [featurePricing, setFeaturePricing] = useState({})
  const [vaultPricing, setVaultPricing] = useState()
  const [licensesIdsSelected, setLicensesIdsSelected] = useState({})
  const getLicensesIdsSelected = (ids) => {
    setLicensesIdsSelected({ ...licensesIdsSelected, ...ids })
  }
  const getFeaturePrices = currentPricing => {
    setFeaturePricing({ ...featurePricing, ...currentPricing })
  }
  const vaultFeature = licenses && licenses[2]
  const featuresForForm = licenses && [licenses[0], licenses[1]]
  const registerLicenses = async () => {
    let licenseIds = []

    for (const key in licensesIdsSelected) {
      licenseIds = [...licenseIds, ...licensesIdsSelected[key]]
    }

    setScreenLoader(true)

    await servicesRegisterUserLicenses({ licenseIds }, getAccessToken)

    window.location.reload()
  }

  return (
    <div className="p-sm">
      <div>
        <Tabs>
          <SectionContainer
            className="mb-xs"
          >
            <VaultSetupForm
              getVaultPricing={setVaultPricing}
              getLicensesIdsSelected={getLicensesIdsSelected}
              vaultFeature={vaultFeature}
              vaultBinding={vaultBinding}
            />
          </SectionContainer>
          <SectionContainer
            className="mb-md"
          >
            <FeaturesForm
              getFeaturePrices={getFeaturePrices}
              getLicensesIdsSelected={getLicensesIdsSelected}
              licenses={featuresForForm}
            />
          </SectionContainer>
          <Table
            className={Styles.table}
            registrationPricing={featurePricing.registration}
            listingPricing={featurePricing.otherFeature}
            vaultPricing={vaultPricing}
            onRegisterLicenses={registerLicenses}
          />
        </Tabs>
      </div>
    </div>
  )
}

export default LicensesForm
